<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t("stock_issue_voucher")}} #{{data.code}}</h4>
                    <p class="text-subtitle-1">{{$t("used_to_issue_items_from_inventory")}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <GoodIssueVoucherForm
                        ref="form"
                        v-model="data"
                        :warehouseId="warehouseId"
                        />
                </v-col>
            </v-row>
            <v-row class="my-2">
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        {{$t("save")}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" @click="onCancel">
                    <v-btn depressed block>
                        {{$t("cancel_btn")}}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import PAlert from '@/components/common/PAlert'
import GoodIssueVoucherForm from './../../components/warehouse/GoodIssueVoucherForm.vue';
import goodsIssueVoucherAPI from './../../services/stockJournal/goodsIssueVoucher';
import goodsIssueVoucher from './../../services/stockJournal/goodsIssueVoucher';
import { v4 as uuid } from 'uuid'

export default {
    components: {
        GoodIssueVoucherForm,
        PAlert
    },
    data() {
        return {
            id: null,
            data: {},
            dataLoading: false,
            loading: false,
            warehouseId: null,
            alert: {
                value: false,
                title: null,
                content: "Are you sure?",
                callback: null
            }
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, value: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            goodsIssueVoucherAPI.update({...this.data}).then(() => {
                this.$router.back();
            }).finally(() => {
                this.loading = false;
            });
        },
        fetch() {
            this.dataLoading = true;
            goodsIssueVoucher.get(this.id).then(res => {
                this.data = {
                    ...res.data,
                    lines: res.data.lines.map(line => {
                        return {
                            ...line,
                            item_id: line.item.id,
                            account_id: line.account.id,
                            dimension_id: line.dimension.id,
                            measure_unit_id: line.measure_unit.id,
                            unit_value: line.value / line.quantity,
                            key: uuid(),
                            id: uuid()
                        }
                    })
                }
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        onCancel() {
            this.alert = {...this.alert, value: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel};
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.warehouseId = this.$route.params.warehouseId;
        this.fetch();
        
    }
}
</script>

<style>

</style>